import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Woman"
});
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M25.5505 16.7921C27.9867 12.5725 26.5412 7.17786 22.3216 4.74167C18.1019 2.30547 12.7073 3.75097 10.2711 7.97058C8.07217 11.7792 9.03609 16.5464 12.3493 19.2293L11.3656 20.9331L7.34486 18.6117L5.95204 21.0242L9.97276 23.3455L8.11567 26.5621L10.5274 27.9545L12.3845 24.738L16.4052 27.0593L17.7981 24.6469L13.7773 22.3255L14.761 20.6218C18.7405 22.1492 23.3512 20.6014 25.5505 16.7921ZM12.6842 9.36377C13.7624 7.49625 15.755 6.34582 17.9114 6.34582C20.0679 6.34582 22.0605 7.49625 23.1387 9.36377C24.2169 11.2313 24.2169 13.5322 23.1387 15.3997C21.4719 18.2866 17.7804 19.2758 14.8935 17.609C12.0065 15.9422 11.0174 12.2507 12.6842 9.36377Z",
  fill: "black"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var woman = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { woman as default };
